import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class AssignedDateColumn extends Column {
    title = 'table.assets.dateAssignedColumn';
    property = 'assignment.assignedOn';
    sortable = true;
    type: CellDisplay = CellDisplay.date;
}
